import { ChargeType } from '@/constants/payment'
import { PAYMENT } from '@/constants'
import { PRODUCT } from '@/utils'

import type { RootState } from '../'
import { getNumberOfTrialDays } from '../selectors'
import { getCachedAppScopes, getItemById } from '../typedSelectors'
import type { PaymentIntent } from './interfaces'

export const getPaymentIntent = (
  state: RootState,
  id: string
): PaymentIntent | null => {
  const item = getItemById(state, id)
  const scopes = getCachedAppScopes(state, item.authorization?.clientId)

  if (!item.payment) {
    return null
  }

  const isDirectCharge = item.payment.frequency === PAYMENT.FREQUENCY.ONCE
  const per_account = item.payment.perAccount
  const icon = item.icons?.small || item.icons?.original || ''
  const return_url = process.env.GATSBY_IFRAME_URL || ''
  const product = item.product || PRODUCT.LiveChat
  const hasScopes = scopes.length > 0

  if (isDirectCharge) {
    return {
      name: item.name,
      price: item.payment.price,
      per_account,
      return_url,
      quantity: 1,
      metadata: {
        icon,
        product,
        itemId: item.id,
        itemSlug: item.slug,
        ownerId: item.ownerId,
        directInstallUrl: item.directInstallUrl,
        privacyPolicyUrl: item.privacyPolicyUrl,
        termsAndConditionsUrl: item.termsAndConditionsUrl,
        clientId: item.authorization?.clientId,
        hasScopes,
        type: ChargeType.DirectCharge,
      },
    }
  }

  return {
    name: item.name,
    price: item.payment.price,
    trial_days: getNumberOfTrialDays(state, id),
    per_account,
    months: 1,
    return_url,
    metadata: {
      icon,
      product,
      itemId: item.id,
      itemSlug: item.slug,
      ownerId: item.ownerId,
      directInstallUrl: item.directInstallUrl,
      privacyPolicyUrl: item.privacyPolicyUrl,
      termsAndConditionsUrl: item.termsAndConditionsUrl,
      clientId: item.authorization?.clientId,
      hasScopes,
      type: ChargeType.RecurrentCharge,
    },
  }
}
